import { classNames } from '@panwds/tailwindcss';
import React, {} from 'react';
import { useTableLayoutEnabled } from '../layouts/table_layout.js';
export function Header(props) {
    const tableLayoutEnabled = useTableLayoutEnabled();
    const { headerstyle, style } = props;
    const classes = classNames('twds-font-lato twds-border-solid twds-border-gray-300 twds-border-0 twds-sticky twds-top-0', tableLayoutEnabled && 'twds-border-b dark:twds-border-gray-950');
    return React.createElement("div", { role: "rowgroup", ...props, className: classes, style: style ?? headerstyle });
}
//# sourceMappingURL=header.js.map